// eslint-disable-next-line no-restricted-imports -- this IS the localization layer
import i18n, { ensureLanguageLoaded } from "@/i18n"
import { atom } from "jotai"
import { I18nLanguage, languageAtom } from "./settings-state"

/** Change only the language currently rendered by i18next, without changing the saved preference. */
export const changeRuntimeLanguage = async (language: I18nLanguage): Promise<I18nLanguage> => {
	if (i18n.resolvedLanguage === language) {
		return language
	}

	try {
		await ensureLanguageLoaded(language)
		await i18n.changeLanguage(language)
		return language
	} catch (error) {
		console.error(`Failed to load locale "${language}". Falling back to English.`, error)
		await i18n.changeLanguage("en")
		return "en"
	}
}

export const changeLanguageAtom = atom(null, async (_get, set, language: I18nLanguage) => {
	const appliedLanguage = await changeRuntimeLanguage(language)
	set(languageAtom, appliedLanguage)
})
